// extracted by mini-css-extract-plugin
export default {"tooltip":"HealthTooltip_tooltip__LNKaG","level":"HealthTooltip_level__MO1Ts","faults":"HealthTooltip_faults__bQybn","faults__item":"HealthTooltip_faults__item__qO5Fg"};